import React, { memo } from 'react';
import { Card, Icon, Row, Skeleton, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import AspectRatioScreenContent from '../../../../shared/components/AspectRatioScreenContent';

import Colors from '../../../../../themes/Colors';
const PlaceholderResolutionsCard = ({ relation, placeholder, loading }) => {
  const { t } = useTranslation();

  return (
    <div className="card-wrapper">
      {loading || !placeholder ? (
        <Skeleton className="skeletonRequiredCard" active paragraph={{ rows: 1, width: 156 }} />
      ) : (
        <>
          <Card className="cardContent">
            <Row type="flex" style={{ flexDirection: 'column', gap: 10 }} justify="space-between">
              <span className="textCard contentTitleRelation">
                <p className="textCard centerCard" style={{ fontSize: '12px', marginRight: '4px' }}>
                  {relation.resolution_width} x {relation.resolution_height}
                </p>
                <Icon type="desktop" style={{ marginTop: '5px', color: Colors.black }} />
                <Tooltip title={t('Displays added in this relation')}>
                  <div className="circle">{relation.displays.length}</div>
                </Tooltip>
              </span>
              <AspectRatioScreenContent relation={relation}>
                <img src={placeholder.base64Image} className="contentRectangleCardImage" alt="" />
              </AspectRatioScreenContent>
            </Row>
          </Card>
        </>
      )}
    </div>
  );
};

export default memo(PlaceholderResolutionsCard);
